"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const source_map_1 = require("source-map");
const convertSourceMap = require("convert-source-map");
class LineMappingImpl {
    constructor(getLine) {
        this.getLine = getLine;
    }
}
function getSourceMap(jsCode) {
    const mapConverter = convertSourceMap.fromSource(jsCode);
    if (mapConverter === null) {
        return;
    }
    return mapConverter.toObject();
}
exports.getSourceMap = getSourceMap;
/**
 * Returns a custom line mapper which maps `node_modules` sources to `null`.
 */
function generateLineMapping(map) {
    if (map) {
        const sourceMap = new source_map_1.SourceMapConsumer(map);
        return new LineMappingImpl((line, column) => {
            const mapping = sourceMap.originalPositionFor({ line, column });
            // NOTE(arjun): Ignoring these directories is a bit of a hack
            if (mapping.source === null ||
                mapping.source.includes('node_modules/') ||
                mapping.source.includes('https://') ||
                mapping.source.includes('goog/') ||
                mapping.source.includes('cljs/') ||
                mapping.source.includes('opt/') ||
                mapping.source.includes('user_code/') ||
                mapping.line === null) {
                return null;
            }
            else {
                return mapping.line;
            }
        });
    }
    else {
        return new LineMappingImpl((line, column) => line);
    }
}
exports.generateLineMapping = generateLineMapping;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic291cmNlTWFwcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21waWxlci9zb3VyY2VNYXBzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEsMkNBQTZEO0FBRTdELHVEQUF1RDtBQUV2RCxNQUFNLGVBQWU7SUFDbkIsWUFBbUIsT0FBd0Q7UUFBeEQsWUFBTyxHQUFQLE9BQU8sQ0FBaUQ7SUFBRyxDQUFDO0NBQ2hGO0FBRUQsU0FBZ0IsWUFBWSxDQUFDLE1BQWM7SUFDekMsTUFBTSxZQUFZLEdBQUcsZ0JBQWdCLENBQUMsVUFBVSxDQUFDLE1BQU0sQ0FBQyxDQUFDO0lBQ3pELElBQUksWUFBWSxLQUFLLElBQUksRUFBRTtRQUN6QixPQUFPO0tBQ1I7SUFDRCxPQUFPLFlBQVksQ0FBQyxRQUFRLEVBQWtCLENBQUM7QUFDakQsQ0FBQztBQU5ELG9DQU1DO0FBRUQ7O0dBRUc7QUFDSCxTQUFnQixtQkFBbUIsQ0FBQyxHQUE2QjtJQUMvRCxJQUFJLEdBQUcsRUFBRTtRQUNQLE1BQU0sU0FBUyxHQUFHLElBQUksOEJBQWlCLENBQUMsR0FBRyxDQUFDLENBQUM7UUFDN0MsT0FBTyxJQUFJLGVBQWUsQ0FBQyxDQUFDLElBQVksRUFBRSxNQUFjLEVBQUUsRUFBRTtZQUMxRCxNQUFNLE9BQU8sR0FBRyxTQUFTLENBQUMsbUJBQW1CLENBQUMsRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLENBQUMsQ0FBQztZQUNoRSw2REFBNkQ7WUFDN0QsSUFBSSxPQUFPLENBQUMsTUFBTSxLQUFLLElBQUk7Z0JBQ3pCLE9BQU8sQ0FBQyxNQUFNLENBQUMsUUFBUSxDQUFDLGVBQWUsQ0FBQztnQkFDeEMsT0FBTyxDQUFDLE1BQU0sQ0FBQyxRQUFRLENBQUMsVUFBVSxDQUFDO2dCQUNuQyxPQUFPLENBQUMsTUFBTSxDQUFDLFFBQVEsQ0FBQyxPQUFPLENBQUM7Z0JBQ2hDLE9BQU8sQ0FBQyxNQUFNLENBQUMsUUFBUSxDQUFDLE9BQU8sQ0FBQztnQkFDaEMsT0FBTyxDQUFDLE1BQU0sQ0FBQyxRQUFRLENBQUMsTUFBTSxDQUFDO2dCQUMvQixPQUFPLENBQUMsTUFBTSxDQUFDLFFBQVEsQ0FBQyxZQUFZLENBQUM7Z0JBQ3JDLE9BQU8sQ0FBQyxJQUFJLEtBQUssSUFBSSxFQUFFO2dCQUN2QixPQUFPLElBQUksQ0FBQzthQUNiO2lCQUFNO2dCQUNMLE9BQU8sT0FBTyxDQUFDLElBQUksQ0FBQzthQUNyQjtRQUNILENBQUMsQ0FBQyxDQUFDO0tBQ0o7U0FBTTtRQUNMLE9BQU8sSUFBSSxlQUFlLENBQUMsQ0FBQyxJQUFZLEVBQUUsTUFBYyxFQUFFLEVBQUUsQ0FBQyxJQUFJLENBQUMsQ0FBQztLQUNwRTtBQUNILENBQUM7QUF0QkQsa0RBc0JDIn0=


//////////////////
// WEBPACK FOOTER
// .-continuations-compiler/dist/src/compiler/sourceMaps.js
// module id = 328
// module chunks = 0